import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import * as S from './change-theme-button.styles';
import type { ChangeThemeButtonProps } from './types';
import { useTheme } from "styled-components";

export const ChangeThemeButton = ({ label, onClick }: ChangeThemeButtonProps) => {
    const theme = useTheme().mode;

    return (
        <S.Button aria-label="Alterar cor do site" onClick={onClick}>
            {theme === 'dark' ? <S.Icon icon={faMoon} /> : <S.Icon icon={faSun} />}
            {label}
        </S.Button>
    )
}